import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  blockUnblockedUser,
  deleteUser,
  fetchUsers,
  getdashboard,
  getVarificationData,
  verifiedUser,
} from "../redux/action/userAction";
import Loader from "../components/other/Loader";
import { fetchProfile } from "../redux/action/authAction";
import { checkStatus, pipViewDate } from "../utils/pip";
import NoRecord from "../components/other/NoRecord";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import PaginationDropdown from "../components/PaginationDropdown";
import ReactPagination from "../components/reactPagination";

const NewDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isToggle, profile } = useSelector((state) => state.authReducer);
  const { isLoading, dashboard, verificationdata } = useSelector(
    (state) => state.userReducer
  );
  const [selectedImage, setSelectedImage] = useState("");
  const dashboardData = [
    {
      id: 1,
      title: "All Users",
      count: dashboard?.userCount,
      icon: "assets/img/user_icon.svg",
      alt: "User Icon",
    },
    {
      id: 2,
      title: "Pro Users",
      count: dashboard?.pro_user_count,
      icon: "assets/img/gem.svg",
      alt: "Gem Icon",
    },
    {
      id: 3,
      title: "All Groups",
      count: dashboard?.totalChatGroupCount,
      icon: "assets/img/people.svg",
      alt: "People Icon",
    },
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  useEffect(() => {
    dispatch(fetchProfile());
    dispatch(getdashboard());
    dispatch(getVarificationData());
  }, [dispatch]);

  const formattedLookingFor = (lookingFor) => {
    return lookingFor
      ? lookingFor
        .split(",")
        .map((part) => part.trim())
        .join(", ")
      : "";
  };

  const paginatedVerification = verificationdata?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleVerifedUser = (value) => {
    const data = {
      user_id: value?.id,
    };
    const callback = (response) => {
      if (response.success) {
        // navigate(pageRoutes?.newDashBoard);
        dispatch(getVarificationData());
      }
    };
    dispatch(verifiedUser({ payload: data, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div class="row ">
              <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                {/* <h3 class="ct_fs_22 ct_ff_roboto mb-4 ct_fw_600 ">Dashboard</h3> */}
                <div class="ct_top_sticky">
                  <div class="row ">
                    {dashboardData?.length != 0 && dashboardData?.map((card) => (
                      <div
                        key={card?.id}
                        className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4 mb-xxl-0"
                      >
                        <div className="ct_dashboard_card">
                          <div class="">
                            <p className="ct_fw_600 mb-2 ct_purple_text mb-0">
                              {card?.title}
                            </p>
                            <h2 className="ct_fs_28 ct_fw_600 mt-0">
                              {card?.count}
                            </h2>
                          </div>
                          <div>
                            <img
                              src={card?.icon}
                              className="me-4"
                              alt={card?.alt}
                            />{" "}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div class="">
                    <div class="d-flex align-items-center justify-content-between gap-2 mb-0 mt-4">
                      <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600">
                        User Verification Request
                      </h4>
                    </div>
                    <div class="table-responsive" >
                      <table className="table ct_custom_table">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Image</th>
                            <th>Name & Location</th>
                            <th>Gender & Looking For</th>
                            <th>Age</th>
                            <th> Join Date</th>
                            <th> Social Account </th>
                            <th> Status </th>
                            <th> Action </th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedVerification &&
                            paginatedVerification.length > 0 ? (
                            paginatedVerification.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <img
                                      src={
                                        item?.images[0] === "No image"
                                          ? "./user_profile.png"
                                          : item?.images[0] ??
                                          "./user_profile.png"
                                      }
                                      alt=""
                                      data-bs-toggle="modal"
                                      data-bs-target="#ct_user_img_preview"
                                      className="ct_img_36 ct_pointer_curser"
                                      onClick={() =>
                                        setSelectedImage(item?.images[0])
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <div>
                                      <h5 className="ct_fs_14 ct_fw_700 mb-0">
                                        {item?.name ?? ""}
                                      </h5>
                                      <p className="mb-0 ct_fs_14 ct_fw_500">
                                        <i className="bi bi-geo-alt me-2"></i>
                                        {item?.city ?? ""}
                                        {item?.city &&
                                          item?.country &&
                                          ", "}{" "}
                                        {item?.country ?? ""}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <p className="mb-0 ct_fw_600 ct_fs_16">
                                      {item?.gender ?? ""}
                                    </p>
                                    <p className="mb-0 ct_fw_600 ct_fs_16 ct_white_space_3_dot_12">
                                      {" "}
                                      {formattedLookingFor(item?.looking_for) ??
                                        ""}
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <p className="mb-0 ct_fw_600 ct_fs_16">
                                      {item?.age} Years
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <p className="mb-0 ct_fw_600 ct_fs_16">
                                      <span>
                                        {pipViewDate(item?.created_at)}
                                      </span>
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <ul className="d-flex align-items-center gap-3">
                                    {item?.facebook_link && (
                                      <li>
                                        <a
                                          href={`https://www.facebook.com/${encodeURIComponent(
                                            item?.facebook_link
                                          )}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i className="fa-brands fa-facebook ct_fs_20 text-dark"></i>
                                        </a>
                                      </li>
                                    )}
                                    {item?.twitter_link && (
                                      <li>
                                        <a
                                          href={`https://www.twitter.com/${encodeURIComponent(
                                            item?.twitter_link
                                          )}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i className="fa-brands fa-twitter ct_fs_20 text-dark"></i>
                                        </a>
                                      </li>
                                    )}
                                    {item?.instagram_link && (
                                      <li>
                                        <a
                                          href={`https://www.instagram.com/${encodeURIComponent(
                                            item?.instagram_link
                                          )}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i className="fa-brands fa-instagram ct_fs_20 text-dark"></i>
                                        </a>
                                      </li>
                                    )}
                                  </ul>
                                </td>
                                <td>
                                  <div className="">
                                    <p
                                      className={`mb-0 ct_fw_600 ct_fs_16 ${checkStatus(item?.is_blocked)
                                        ? "ct_red_text"
                                        : "ct_green_text"
                                        }`}
                                    >
                                      {checkStatus(item?.is_blocked)
                                        ? "Blocked"
                                        : "Active"}
                                    </p>
                                  </div>
                                </td>
                                <td class="text-start">
                                  <div>
                                    <div className="d-flex align-items-center gap-4">
                                      <a
                                        className=" ct_view_grey_btn"
                                        onClick={() =>
                                          navigate(
                                            pageRoutes?.verificationRequest,
                                            {
                                              state: { value: item },
                                            }
                                          )
                                        }
                                      >
                                        {" "}
                                        <i class="fa-solid fa-eye ct_pointer_curser"></i>
                                      </a>
                                      <a
                                        className="ct_view_grey_btn"
                                        onClick={() => handleVerifedUser(item)}
                                      >
                                        {" "}
                                        <i class="fa-solid fa-check ct_pointer_curser"></i>{" "}
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={9}>
                                <NoRecord />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {paginatedVerification &&
                      paginatedVerification?.length != 0 && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mt-4">
                            <div>
                              <PaginationDropdown
                                onChange={(val) => {
                                  setUserPerPages(val);
                                  setCurrentPage(0);
                                }}
                              />
                            </div>
                            <div>
                              <ReactPagination
                                pageCount={Math.ceil(
                                  verificationdata?.length / usersPerPage
                                )}
                                onPageChange={handlePageClick}
                              />
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade ct_assets_modal"
          id="ct_user_img_preview"
          tabindex="-1"
          aria-labelledby="ct_user_img_previewLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header pb-0 border-0">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body mt-0">
                <img
                  src={selectedImage || "./user_profile.png"}
                  alt=""
                  class="ct_img_400_big"
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default NewDashboard;
